import CommandesBadge from '../CommandesBadge';
import ReservationsTablesNavItem from '../ReservationsTablesNavItem';
import SidebarNav from '../sidebar/SidebarNav';
import SidebarItem, { NavCountBadgeUrgent } from '../sidebar/SidebarItem';

const CommercantSidebarNav = ({
  sections,
  location,
  onNavigate,
  reservationTableEnabled,
  commandesBadgeProps,
  tableReservationsPendingCount,
  documentsActionRequiredCount = 0,
}) => (
  <SidebarNav
    sections={sections}
    location={location}
    renderItem={(item, { isActive }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onNavigate(item);
      };

      if (item.variant === 'commandes') {
        return (
          <CommandesBadge
            key={item.id}
            isActive={isActive}
            pendingCount={commandesBadgeProps.pendingCount}
            connected={commandesBadgeProps.connected}
            onClick={() => onNavigate(item)}
          />
        );
      }

      if (item.variant === 'reservations-tables' && reservationTableEnabled) {
        return (
          <ReservationsTablesNavItem
            key={item.id}
            pendingCount={tableReservationsPendingCount}
            isActive={isActive}
            onClick={() => onNavigate(item)}
          />
        );
      }

      const Icon = item.icon;

      return (
        <SidebarItem
          key={item.id}
          as="a"
          icon={Icon}
          label={item.name}
          active={isActive}
          href={item.href}
          onClick={handleClick}
          badge={item.id === 'documents' && documentsActionRequiredCount > 0
            ? <NavCountBadgeUrgent count={documentsActionRequiredCount} />
            : null}
        />
      );
    }}
  />
);

export default CommercantSidebarNav;
